import {
  Button,
  type ButtonProps,
  CircularProgress,
  type SxProps,
  type Theme
} from '@mui/material'
import { forwardRef } from 'react'

export type MolsonButtonProps = ButtonProps & {
  dataTestId?: string
  hasIconOnly?: boolean
  sx?: SxProps<Theme>
  loading?: boolean
  loadingPosition?: 'start' | 'end'
  disabled?: boolean
}

export type ButtonVariantType = 'text' | 'contained' | 'outlined' | 'linkButton'

export const MolsonButton = forwardRef<HTMLButtonElement, MolsonButtonProps>(
  function MolsonButton(props, ref) {
    const {
      dataTestId,
      children,
      hasIconOnly = false,
      sx,
      variant,
      loading,
      loadingPosition = 'end',
      disabled,
      ...rest
    } = props
    const getPadding = () => {
      if (variant === 'linkButton') {
        return '0'
      }
      return '10px 16px !important'
    }

    const padding = hasIconOnly ? '10px 0px !important' : getPadding()

    return (
      <Button
        disableFocusRipple={variant === 'linkButton'}
        disableRipple={variant === 'linkButton'}
        disableTouchRipple={variant === 'linkButton'}
        ref={ref}
        data-testid={dataTestId}
        variant={variant}
        {...rest}
        disabled={disabled || loading}
        sx={{
          flexDirection: loadingPosition === 'start' ? 'row-reverse' : 'row',
          padding: padding,
          ...sx
        }}
      >
        {children}
        {loading && <CircularProgress size={16} sx={{ opacity: 0.5 }} />}
      </Button>
    )
  }
)
